// src/store/index.ts

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import retirosReducer from './slices/retirosSlice';
import disputasReducer from './slices/disputasSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    retiros: retirosReducer,
    disputas: disputasReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
